$(document).ready(function(){
  
  $('.search-form__container .search-bar__close').click(function(){
  	$('.mobile-nav-wrapper').removeClass('is-transitioning');
  });
  
 // ---- featured image click js code --------
//   $(".thumbnails-wrapper .thumbnails-slider__btn.slick-arrow").click(function(){
//       $(".slick-track").find(".slick-current").find("a").trigger("click");
//       $('.product-single__thumbnail.active-thumb').trigger("click");
//   });
  $(".product_slide_icon_img.prev_icon").click(function(){
      $('.active-thumb').parent().prev().find("a").trigger("click");
  });
  $(".product_slide_icon_img.next_icon").click(function(){
      $('.active-thumb').parent().next().find("a").trigger("click");
  });
  
});